let video = {
    init() {

        $('.overlay').click(function() {
            $(this).fadeOut(300);


            var iframe  = $(this).parent().find('iframe');
            var id  = $(this).find('.play').attr('id');
            var iframe_src = iframe.attr('src');
            var iframe_src = iframe_src+'?title=1&byline=0&portrait=0&autoplay=1';
            $(this).parent().find('iframe').attr('src', iframe_src);
            //console.log(id);

            window.dataLayer = window.dataLayer || [];
            var Videotitle = '';
            $.getJSON('https://www.youtube.com/oembed?url=http://www.youtube.com/watch?v='+id+'&format=json',function(data,status,xhr){
                //console.log('1');
                if(data.title){
                    Videotitle = data.title;

                    window.dataLayer.push({
                        event: 'Video',
                        'Action': 'Play',
                        'Videotitle': Videotitle,  // récupérer dynamiquement le titre de la vidéo youtube ou vimeo
                    });
                }
            });

            $.getJSON('https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/'+id,function(data,status,xhr){
                //console.log('2');
                if(data.title){
                    Videotitle = data.title;

                    window.dataLayer.push({
                        event: 'Video',
                        'Action': 'Play',
                        'Videotitle': Videotitle,  // récupérer dynamiquement le titre de la vidéo youtube ou vimeo
                    });
                }
            });


        });
    }
}

export default video;
